import { render, staticRenderFns } from "./InspectResult1.vue?vue&type=template&id=246b12fd&scoped=true"
import script from "./InspectResult1.vue?vue&type=script&lang=js"
export * from "./InspectResult1.vue?vue&type=script&lang=js"
import style0 from "./InspectResult1.vue?vue&type=style&index=0&id=246b12fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b12fd",
  null
  
)

export default component.exports